import { Injectable, Optional } from '@angular/core';
import { Firestore, addDoc, collection, serverTimestamp } from '@angular/fire/firestore';

export type ContactMessage = {
  name: string;
  email: string;
  company?: string;
  message: string;
};

@Injectable({ providedIn: 'root' })
export class ContactService {
  constructor(@Optional() private firestore: Firestore | null) {}

  async sendMessage(payload: ContactMessage): Promise<void> {
    if (!this.firestore) {
      throw new Error(
          'Firestore is not configured. Set Firebase config and enable AngularFire.'
      );
    }

    const cleanPayload = {
      name: payload.name.trim(),
      email: payload.email.trim().toLowerCase(),
      company: (payload.company ?? '').trim(),
      message: payload.message.trim(),
    };

    const ref = collection(this.firestore, 'contactMessages');

    await addDoc(ref, {
      ...cleanPayload,
      createdAt: serverTimestamp(),
      source: 'web',
      status: 'pending'
    });
  }
}
